import { render } from "./SiteMetadataView.vue?vue&type=template&id=47292b72"
import script from "./SiteMetadataView.vue?vue&type=script&lang=js"
export * from "./SiteMetadataView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__